export default __webpack_public_path__ + "static/media/slide4.0641fe85.jpg";